// extracted by mini-css-extract-plugin
export default {"companyContainer":"JM-z","companyImage":"KM-z","container":"LM-z","heading":"MM-z","darkText":"NM-z","smallHeading":"OM-z","darkBackground":"PM-z","whiteBackground":"QM-z"};